import WishlistDataProvider from 'app/modules/Wishlist/WishlistDataProvider';

export default WishlistDataProvider;
